<template>
	<el-dialog :title="$t('common.verify')" width="380px" :visible.sync="visible" :close-on-click-modal="false"
		append-to-body @closed="onClosed">
		<div class="slider-captcha" v-loading="loading">
			<div class="image-panel" ref="imagePanel" :style="{ width: imgWidth + 'px', height: imgHeight + 'px' }">
				<img v-if="backImg" class="bg-img" :src="backImg" alt="">
				<div v-if="blockImg" class="block-img" :style="blockStyle">
					<img :src="blockImg" alt="">
				</div>
				<div class="refresh-btn" @click="loadCaptcha">
					<i class="el-icon-refresh-right"></i>
				</div>
				<div v-if="tip" class="tip" :class="tipOk ? 'ok' : 'err'">{{ tip }}</div>
			</div>
			<div class="slider-bar" ref="sliderBar" :style="{ width: imgWidth + 'px' }">
				<div class="slider-track" :style="{ width: trackWidth + 'px' }"></div>
				<span class="slider-text">{{ dragging ? '' : $t('captcha.slideTip') }}</span>
				<div class="slider-btn" :style="{ left: btnLeft + 'px' }" @mousedown="onDragStart"
					@touchstart.prevent="onDragStart">
					<i :class="btnIcon"></i>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: 'CaptchaSlider',
	data() {
		return {
			visible: false,
			loading: false,
			callback: null,
			imgWidth: 310,
			imgHeight: 155,
			blockWidth: 47,
			btnSize: 40,
			backImg: '',
			blockImg: '',
			token: '',
			dragging: false,
			startLeft: 0,
			btnLeft: 0,
			trackWidth: 0,
			maxLeft: 0,
			tip: '',
			tipOk: false,
			btnIcon: 'el-icon-d-arrow-right'
		}
	},
	computed: {
		blockStyle() {
			return {
				left: this.btnLeft + 'px',
				top: '0px',
				width: this.blockWidth + 'px',
				height: this.imgHeight + 'px'
			}
		}
	},
	beforeDestroy() {
		this.unbindDrag()
	},
	methods: {
		open(callback) {
			this.callback = callback
			this.visible = true
			this.loadCaptcha()
		},
		onClosed() {
			this.resetSlider()
			this.unbindDrag()
		},
		resetSlider() {
			this.btnLeft = 0
			this.trackWidth = 0
			this.tip = ''
			this.btnIcon = 'el-icon-d-arrow-right'
			this.dragging = false
		},
		updateLayoutSize() {
			if (this.$refs.imagePanel) {
				this.imgWidth = this.$refs.imagePanel.offsetWidth || 310
				this.imgHeight = this.$refs.imagePanel.offsetHeight || 155
			}
			this.maxLeft = Math.max(0, this.imgWidth - this.blockWidth)
		},
		loadCaptcha() {
			this.loading = true
			this.resetSlider()
			this.$http({
				url: '/captcha/slider/get',
				method: 'post',
				data: { captchaType: 'blockPuzzle' }
			}).then(model => {
				if (model.repCode !== '0000') {
					this.$message.error(model.repMsg || this.$t('captcha.error'))
					return
				}
				const data = model.repData
				this.backImg = 'data:image/png;base64,' + data.originalImageBase64
				this.blockImg = 'data:image/png;base64,' + data.jigsawImageBase64
				this.token = data.token
				this.$nextTick(() => {
					this.updateLayoutSize()
				})
			}).finally(() => {
				this.loading = false
			})
		},
		onDragStart(e) {
			if (!this.token || !this.$refs.sliderBar) return
			this.dragging = true
			const barRect = this.$refs.sliderBar.getBoundingClientRect()
			this.startLeft = Math.floor(this.getClientX(e) - barRect.left)
			this.bindDrag()
		},
		onDragMove(e) {
			if (!this.dragging || !this.$refs.sliderBar) return
			const bar = this.$refs.sliderBar
			const barRect = bar.getBoundingClientRect()
			const barWidth = bar.offsetWidth
			const halfBlock = Math.floor(this.blockWidth / 2)
			let moveInBar = this.getClientX(e) - barRect.left
			if (moveInBar >= barWidth - halfBlock - 2) {
				moveInBar = barWidth - halfBlock - 2
			}
			if (moveInBar <= 0) {
				moveInBar = halfBlock
			}
			let left = moveInBar - this.startLeft
			left = Math.max(0, Math.min(left, this.maxLeft))
			this.btnLeft = left
			this.trackWidth = left
		},
		onDragEnd() {
			if (!this.dragging) return
			this.dragging = false
			this.unbindDrag()
			this.verify()
		},
		getClientX(e) {
			return e.touches ? e.touches[0].clientX : e.clientX
		},
		bindDrag() {
			document.addEventListener('mousemove', this.onDragMove)
			document.addEventListener('mouseup', this.onDragEnd)
			document.addEventListener('touchmove', this.onDragMove, { passive: false })
			document.addEventListener('touchend', this.onDragEnd)
		},
		unbindDrag() {
			document.removeEventListener('mousemove', this.onDragMove)
			document.removeEventListener('mouseup', this.onDragEnd)
			document.removeEventListener('touchmove', this.onDragMove)
			document.removeEventListener('touchend', this.onDragEnd)
		},
		verify() {
			const moveLeftDistance = Math.round(this.btnLeft * 310 / this.imgWidth)
			const point = { x: moveLeftDistance, y: 5.0 }
			const pointJson = JSON.stringify(point)
			this.$http({
				url: '/captcha/slider/check',
				method: 'post',
				data: {
					captchaType: 'blockPuzzle',
					pointJson,
					token: this.token
				}
			}).then(model => {
				if (model.repCode === '0000') {
					this.tipOk = true
					this.tip = this.$t('captcha.success')
					this.btnIcon = 'el-icon-check'
					// check 接口不会返回 captchaVerification，需客户端拼接（AjCaptcha 官方做法，aes-status=false）
					const captchaVerification = this.token + '---' + pointJson
					setTimeout(() => {
						this.visible = false
						this.callback && this.callback(captchaVerification)
					}, 500)
				} else {
					this.tipOk = false
					this.tip = this.$t('captcha.error')
					this.btnIcon = 'el-icon-close'
					setTimeout(() => this.loadCaptcha(), 800)
				}
			})
		}
	}
}
</script>

<style scoped lang="scss">
.slider-captcha {
	.image-panel {
		position: relative;
		margin: 0 auto 12px;
		border-radius: 4px;
		overflow: hidden;
		background: #f5f5f5;

		.bg-img {
			width: 100%;
			height: 100%;
			display: block;
		}

		.block-img {
			position: absolute;
			z-index: 2;

			img {
				width: 100%;
				height: 100%;
				display: block;
			}
		}

		.refresh-btn {
			position: absolute;
			top: 4px;
			right: 4px;
			z-index: 3;
			width: 28px;
			height: 28px;
			line-height: 28px;
			text-align: center;
			background: rgba(0, 0, 0, 0.35);
			color: #fff;
			border-radius: 4px;
			cursor: pointer;
		}

		.tip {
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			padding: 4px 8px;
			color: #fff;
			font-size: 12px;
			text-align: center;

			&.ok {
				background: rgba(92, 184, 92, 0.85);
			}

			&.err {
				background: rgba(217, 83, 79, 0.85);
			}
		}
	}

	.slider-bar {
		position: relative;
		height: 40px;
		margin: 0 auto;
		background: #e8e8e8;
		border-radius: 4px;
		line-height: 40px;
		text-align: center;
		user-select: none;

		.slider-track {
			position: absolute;
			left: 0;
			top: 0;
			height: 100%;
			background: #d1e9ff;
			border-radius: 4px 0 0 4px;
		}

		.slider-text {
			position: relative;
			z-index: 1;
			color: #999;
			font-size: 13px;
		}

		.slider-btn {
			position: absolute;
			top: 0;
			z-index: 2;
			width: 40px;
			height: 40px;
			background: #fff;
			border: 1px solid #ccc;
			border-radius: 4px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
		}
	}
}
</style>
